import { useTranslation } from 'react-i18next';
import { ChangeLog } from '../../types';
import { REPORT_STATUS } from '../../lib/constants';

interface HistoryDetailsProps {
  changeLogs: ChangeLog[];
}

const getStatusColor = (status: string) => {
  switch (status) {
    case REPORT_STATUS.REPORTED:
      return 'bg-neutral-100 font-bold opacity-90 text-status-toDo border-solid border-status-toDo border-2 rounded';

    case REPORT_STATUS.IN_PROGRESS:
      return 'bg-neutral-100 font-bold opacity-90 text-status-inProgress border-solid border-status-inProgress border-2 rounded';
    default:
      return 'bg-neutral-100 font-bold opacity-90 text-status-done border-solid border-status-done border-2 rounded';
  }
};

export function HistoryDetails({ changeLogs }: HistoryDetailsProps) {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="font-bold text-title pt-10 pb-5">{t('details.history.title')}</h3>
      {changeLogs.map((changeLog, i) => {
        return (
          <div className="mb-5" key={changeLog.created + i.toString()}>
            <div className="text-label mb-1">
              {new Date(changeLog.created).toLocaleDateString()}:{' '}
              {t('details.history.statusChangeDescription')}
            </div>
            <div className="flex gap-4">
              <div className={getStatusColor(changeLog.from.name)}>
                <div className="py-1 px-4 text-label">
                  {t(`report.status.${changeLog.from.name}`)}
                </div>
              </div>
              <i className="ri-arrow-right-s-line chevron col-start-2 row-start-1 row-span-2 self-center" />
              <div className={getStatusColor(changeLog.to.name)}>
                <div className="py-1 px-4 text-label">
                  {t(`report.status.${changeLog.to.name}`)}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
